/**
 * 创建websoket
 **/
import Tool from "@/assets/js/common/utils.js";
import $store from "@/store/index";
import SocketApi from "@/assets/js/common/websocket";

let protocol = document.location.protocol === "https:" ? "wss://" : "ws://"; //获取协议
let session = Tool.getCookie();
export const createWebsocket = {
  getDownlowd(type, key, needSendHeart, callBack) {
    let wsUrl = $store.state.config.recordServiceWsUrl;
    let dataRequest = {
      url: protocol + wsUrl + "?sid=" + session,
      sendHeart: needSendHeart,
      callBack: callBack,
    };
    // 初始化
    if (type == "off") {
      this.getDownlowdWs.off(); //关闭
    } else if (type == "stop") {
      this.getDownlowdWs.stop(key);
    } else {
      if (wsUrl && session) {
        //如果获取到url 并且获取到session之后才可以创建websocket
        this.getDownlowdWs = new SocketApi(dataRequest);
        this.getDownlowdWs.init();
      }
    }
    $store.state.websocket.getDownlowd = this.getDownlowdWs;
  },
};
export default {
  install: function(vm) {
    vm.prototype.$createWebsocket = createWebsocket;
  },
};
